<template>
	<!--  -->
    <div v-if="!isLoading && project !== null">
        <div class="tabs">
            <ul>
                <li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Общая
                    информация</a></li>
                <li @click="changeCurrentTab(2)" class="tab tab2" :class="tabNum === 2 ? 'is-active' : ''"><a>Команда</a></li>
            </ul>
        </div>
        <form id="project_form">
            <div class="errors-block" v-if="errors.length">
                <b>Пожалуйста, заполните поля:</b>
                <ul>
                    <li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
                </ul>
            </div>
            <div v-if="!selectedCompetition?.name">
                <p class="help_text" @click="$parent.showModalQuestion"> <FontAwesomeIcon icon="question"></FontAwesomeIcon> Почему я не вижу обязательные поля для этого проекта?</p>
            </div>
            <div id="tabContent">
                <div v-if="tabNum === 1" class="content-tab">
                    <div class="columns">
                        <div class="column">
                            <BaseInput
                                    label="Название фильма на русском языке"
                                    :value="project.name"
                                    v-if="isFieldVisible('name')"
                                    objectKey="name"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>

                            <BaseInput3
                                    label="Название фильма на английском языке"
                                    v-model="project.project_data.name_english"
                                    objectKey="treiler"
																		:is-required="true"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                                    @onChange="saveData"
                            ></BaseInput3>

                            <BaseInput
                                    label="Год выпуска"
                                    :value="project.publish_year"
                                    v-if="isFieldVisible('publish_year')"
                                    objectKey="publish_year"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>

                            <BaseInput
                                    label="Хронометраж (мин.)"
                                    :value="project.chronometr"
                                    v-if="isFieldVisible('chronometr')"
                                    objectKey="chronometr"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>

                            <div class="field">
                                <label :class="this.isFieldRequired('zhanr') ? 'req': ''">Вид фильма</label>
                                <div>
																		<div class="checkbox__wrapper">
                                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_0"
                                               value="Документальное короткометражное кино" v-model="project.zhanr">
                                        <label for="project_zhanr_0">Документальное короткометражное кино</label>
																		</div>
                                    <div class="checkbox__wrapper">
                                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_1"
                                           value="Игровое короткометражное кино" v-model="project.zhanr">
                                    <label for="project_zhanr_1">Игровое короткометражное кино</label>
																		</div>
                                        <div class="checkbox__wrapper">
                                    <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_2"
                                           value="Анимационное короткометражное кино" v-model="project.zhanr">
                                    <label for="project_zhanr_2">Анимационное короткометражное кино</label>
																				</div>
                                </div>
                            </div>

                            <div class="field" v-if="isFieldVisible('production')">
                                <label :class="this.isFieldRequired('production') ? 'req': ''">Производство (кинокомпания, студия
                                    и.т.д.)</label>
                                <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                          v-model="project.production"></textarea>
                            </div>

                        </div>
                        <div class="column">

                            <div v-if="project.afisha">
                                <img :src="'/uploads/images/' + project.afisha" id="image">
                            </div>

                            <vue-cropper
                                    ref="cropper"
                                    :src="imgSrc"
                                    alt="Source Image"
                                    :aspect-ratio="366 / 546"
                                    preview=".preview"
                                    v-if="imgSrc != ''"
                            >
                            </vue-cropper>
                            <button class="button2" @click.prevent="cropImage" v-if="imgSrc != ''" style="margin-right: 40px;">
                                Сохранить изображение
                            </button>

                            <div class="field" v-if="isFieldVisible('afisha')">
                                <label :class="this.isFieldRequired('afisha') ? 'req': ''" for="project_afisha">Афиша проекта /
                                    Картинка характеризующая проект (Формат jpeg/png. Макс. 1,5 мегабайт)</label>
                                <i class="fas fa-download"></i>
                                <input :disabled="isDataUpdating" type="file" accept="image/*" id="project_afisha"
                                       name="project[afisha]" @change="setImage">
                                <div id="fileList"></div>
                                <p style="font-size: 13px; margin-top: 10px;">Ссылка на скачивание постера фильма
                                    * (ссылка должна быть действительна до даты окончания конкурса/акции)</p>
                            </div>

                            <TinymceEditor
                                    label="Краткая аннотация на русском языке"
                                    :value="project.annotation"
                                    v-if="isFieldVisible('annotation')"
                                    objectKey="annotation"
                                    description="Сделайте краткое описание вашего фильма"
                                    :isDataUpdating="isDataUpdating"
                            ></TinymceEditor>

                            <TinymceEditor
                                    label="Краткая аннотация на английском языке"
                                    :value="project.project_data.annotation_english"
                                    max_chars="5000"
                                    v-if="isFieldVisible('annotation_english')"
                                    objectKey="annotation_english"
																		:is-required="true"
                                    parentKey="project_data"
                                    description="Сделайте краткое описание вашего фильма"
                                    :isDataUpdating="isDataUpdating"
                            ></TinymceEditor>
                        </div>
                    </div>
										<div class="field">
                        <label class="req" style="cursor: pointer" for="pravoobladatel">Правообладатель</label>
                        <input style="cursor: pointer" @change="saveData" v-model="project.project_data.pravoobladatel" type="radio" value="company" id="prav_company">
                        <label  style="cursor: pointer" for="prav_company">Компания</label>

                        <input style="cursor: pointer" @change="saveData" v-model="project.project_data.pravoobladatel" type="radio" value="fis" id="prav_fis">
                        <label style="cursor: pointer" for="prav_fis">Физическое лицо</label>
										</div>


                    <div class="columns">
                        <div class="column">
                            <BaseInput
                                    label="Название компании или ФИО физического лица кому принадлежат права на фильм"
                                    :value="project.film_rights"
                                    v-if="isFieldVisible('film_rights')"
                                    objectKey="film_rights"
                                    description="Укажите фамилию, имя и отчество человека, которому принадлежат права на видеопроизведение или название компании"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>
                        </div>
                        <div class="column">
                            <BaseInput
                                    label="Номер телефона"
                                    :value="project.film_rights_phone"
                                    v-if="isFieldVisible('film_rights_phone')"
                                    objectKey="film_rights_phone"
                                    description="Укажите номер телефона человека, которому принадлежат права на видеопроизведение"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>
                        </div>
                        <div class="column">
                            <BaseInput
                                    label="Email"
                                    :value="project.film_rights_email"
                                    v-if="isFieldVisible('film_rights_email')"
                                    objectKey="film_rights_email"
                                    description="Укажите электронную почту человека, которому принадлежат права на видеопроизведение"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            * по данным контактам организаторы будут связываться с Правообладателем при прохождении фильма в программу Фестиваля
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <BaseInput
                                    label="Закрытая ссылка для просмотра фильма"
                                    :value="project.video_link"
                                    v-if="isFieldVisible('video_link')"
                                    objectKey="video_link"
                                    description="Ссылка для отборочной комиссии. Ссылка должна быть действительна до даты окончания конкурса/акции"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>
                            <div class="field" v-if="isFieldVisible('tagline')">
                                <label :class="this.isFieldRequired('tagline') ? 'req': ''">Закрытая ссылка на скачивание
                                    фильма</label>
                                <p class="field_description">Максимальное разрешение для показа картины. Ссылка должна быть
                                    действительна до даты окончания конкурса/акции</p>
                                <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                          v-model="project.tagline"></textarea>
                            </div>

                            <div class="field" v-if="isFieldVisible('social_videolink')">
                                <label :class="this.isFieldRequired('social_videolink') ? 'req': ''">Ссылка на фильм (видеоролик,
                                    клип), размещенный в социальных сетях</label>
                                <p class="field_description">В этом поле, если есть, укажите ссылки на посты в любых соцсетях, в
                                    которых содержатся ссылки на трейлер или тизер проекта.</p>
                                <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                          v-model="project.social_videolink"></textarea>
                            </div>

                            <BaseInput
                                    label="Ссылка на исходные материалы для фильма"
                                    :value="project.video_source"
                                    v-if="isFieldVisible('video_source')"
                                    objectKey="video_source"
                                    description="Здесь разместите ссылки на любые отснятые, но не обработанные или не смонтированные материалы — они пригодятся журналистам для того, чтобы создать сюжет на телеканале и коротко рассказать о вашем проекте среди общей подборки. Пожалуйста, сделайте для исходников отдельную папку и используйте название финального видеоролика в названиях файлов."
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>

                            <div class="field" v-if="isFieldVisible('priority_social')">
                                <label :class="this.isFieldRequired('priority_social') ? 'req': ''">Ссылки на социальные сети
                                    проекта</label>
                                <p class="field_description">В этом поле укажите ссылку на одну приоритетную социальную сеть
                                    проекта.</p>
                                <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                          v-model="project.priority_social"></textarea>
                            </div>

                            <BaseInput2
                                    label="Ссылка на кадры из фильма"
                                    v-if="isFieldVisible('command_photo')"
                                    v-model="commandphoto"
                                    objectKey="command_photo"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput2>

                            <BaseInput2
                                    label="Ссылка на фотографию режиссера"
                                    v-if="isFieldVisible('regiser_photo')"
                                    v-model="project.project_data.regiser_photo"
                                    objectKey="regiser_photo"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput2>

                            <BaseInput
                                    label="Кому принадлежат права на музыку, использованную в фильме (видеоролике, клипе)"
                                    :value="project.music_rights"
                                    v-if="isFieldVisible('music_rights')"
                                    objectKey="music_rights"
                                    description="Имеете ли вы право использовать музыку, которая звучит в вашем фильме (видеоролике, клипе)"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>

                            <BaseLocation
                                    v-if="project !== null && countriesinput.length > 0"
                                    :countriesinput="countriesinput"
                                    countryKey="country"
                                    cityKey="city"
                                    regionKey="region"
                                    labelCountry="Страна, которую вы представляете"
                                    labelCity="Город, который вы представляете"
                                    labelRegion="Регион, который вы представляете"
                                    :isDataUpdating="isDataUpdating"
                            ></BaseLocation>

                            <BaseInput
                                    label="На каком языке снят фильм (видеоролик, клип)"
                                    :value="project.film_language"
                                    v-if="isFieldVisible('film_language')"
                                    objectKey="film_language"
                                    :isDataUpdated="isDataUpdating"
                                    :isFormSubmitted="isSubmitted"
                            ></BaseInput>

                            <div class="field" v-if="isFieldVisible('motivation')">
                                <label :class="this.isFieldRequired('motivation') ? 'req': ''">Мотивация (несколько слов о том, почему
                                    для вас было важно рассказать именно эту историю)</label>
                                <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                          v-model="project.motivation"></textarea>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field" v-if="isFieldVisible('inroles')">
                                <label :class="this.isFieldRequired('inroles') ? 'req': ''">В ролях</label>
                                <textarea :disabled="isDataUpdating" @change="saveData" placeholder="" v-model="inroles"></textarea>
                            </div>
                            <div class="field" v-if="isFieldVisible('age_limit')">
                                <BaseInput3
                                        label="Возрастное ограничение фильма (0+, 6+, 12+, 16+ или 18+)"
                                        v-model="project.project_data.age_limit"
                                        objectKey="age_limit"
                                        :isDataUpdated="isDataUpdating"
                                        :isFormSubmitted="isSubmitted"
                                        @onChange="saveData"
                                ></BaseInput3>
                            </div>

                            <div class="field" v-if="isFieldVisible('treiler')">
                                <BaseInput3
                                        label="Ссылка на трейлер (только YouTube или Vimeo)"
                                        v-model="project.project_data.treiler"
                                        objectKey="treiler"
                                        :isDataUpdated="isDataUpdating"
                                        :isFormSubmitted="isSubmitted"
                                        @onChange="saveData"
                                ></BaseInput3>
                            </div>

                            <div class="field" v-if="isFieldVisible('premiera')">
                                <label :class="this.isFieldRequired('premiera') ? 'req': ''">Премьерность фильма</label>
																<p class="description">на фестиваль принимаются только фильмы с премьерным показом</p>
                                <div class="select-field">
                                    <select :disabled="isDataUpdating" @change="saveData" v-model="project.project_data.premiera">
                                        <option value="мировая">мировая</option>
                                        <option value="российская">российская</option>
                                    </select>
                                </div>
                            </div>

                            <div class="checkbox__wrapper">
                                <input type="checkbox" @change="saveData" id="russian_subtitles" value="yes" v-model="project.project_data.russian_subtitles">
                                <label class="req" for="russian_subtitles">Наличие русских субтитров - для фильмов на национальных и иностранных языках</label>
                            </div>

                            <div class="checkbox__wrapper">
                                <input type="checkbox" @change="saveData" id="russian_premiera" value="yes" v-model="project.project_data.russian_premiera">
                                <label for="russian_premiera">российская премьера</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="tabNum === 2" class="content-tab">
                    <div class="columns">
                        <div class="column">
                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Автор(ы) сценария"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="scenarist_text"
                                            v-if="isFieldVisible('scenarist_text')"
                                            objectKey="scenarist_text"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column">
                                    <BaseInput2
                                            label="Номер телефона"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="scenarist_phone"
                                            v-if="isFieldVisible('scenarist_phone')"
                                            objectKey="scenarist_phone"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column">
                                    <BaseInput2
                                            label="Электронная почта"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="scenarist_email"
                                            v-if="isFieldVisible('scenarist_email')"
                                            objectKey="scenarist_email"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Автор(ы) сценария (на английском)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="project.project_data.scenarist_text_english"
                                            v-if="isFieldVisible('scenarist_text_english')"
                                            objectKey="scenarist_text_english"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
																<div class="column"></div>
                                <div class="column"></div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Режиссер(ы)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="regiser_text"
                                            v-if="isFieldVisible('regiser_text')"
                                            objectKey="regiser_text"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column">
                                    <BaseInput2
                                            label="Номер телефона"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="regiser_phone"
                                            v-if="isFieldVisible('regiser_phone')"
                                            objectKey="regiser_phone"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column">
                                    <BaseInput2
                                            label="Электронная почта"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="regiser_email"
                                            v-if="isFieldVisible('regiser_email')"
                                            objectKey="regiser_email"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Режиссер(ы) (на английском)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="project.project_data.regiser_text_english"
                                            v-if="isFieldVisible('regiser_text_english')"
                                            objectKey="regiser_text_english"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column"></div>
                                <div class="column"></div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <div class="field" v-if="isFieldVisible('regiser_bio')">
                                        <label :class="this.isFieldRequired('regiser_bio') ? 'req': ''">Краткая биография режиссера на русском языке</label>
                                        <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                                  v-model="regiser_bio"></textarea>
                                    </div>
                                </div>
                                <div class="column">
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <div class="field" v-if="isFieldVisible('regiser_bio_english')">
                                        <label :class="this.isFieldRequired('regiser_bio_english') ? 'req': ''">Краткая биография режиссера на английском языке</label>
                                        <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                                  v-model="project.project_data.regiser_bio_english"></textarea>
                                    </div>
                                </div>
                                <div class="column">
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <div class="field" v-if="isFieldVisible('regiser_filmografia')">
                                        <label :class="this.isFieldRequired('regiser_filmografia') ? 'req': ''">Краткая фильмография режиссера на русском языке</label>
                                        <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                                  v-model="project.project_data.regiser_filmografia"></textarea>
                                    </div>
                                </div>
                                <div class="column">
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <div class="field" v-if="isFieldVisible('regiser_filmografia_english')">
                                        <label :class="this.isFieldRequired('regiser_filmografia_english') ? 'req': ''">Краткая фильмография режиссера на английском языке</label>
                                        <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                                                  v-model="project.project_data.regiser_filmografia_english"></textarea>
                                    </div>
                                </div>
                                <div class="column">
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Продюсер(ы)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="producer_text"
                                            v-if="isFieldVisible('producer_text')"
                                            objectKey="producer_text"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column">
                                    <BaseInput2
                                            label="Номер телефона"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="producer_phone"
                                            v-if="isFieldVisible('producer_phone')"
                                            objectKey="producer_phone"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column">
                                    <BaseInput2
                                            label="Электронная почта"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="producer_email"
                                            v-if="isFieldVisible('producer_email')"
                                            objectKey="producer_email"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                            </div>


                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Продюсер(ы) (на анлгийском)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="project.project_data.producer_text_english"
                                            v-if="isFieldVisible('producer_text_english')"
                                            objectKey="producer_text_english"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
																<div class="column"></div>
																<div class="column"></div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <BaseInput2
                                            label="Оператор(ы)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="operator_text"
                                            v-if="isFieldVisible('operator_text')"
                                            objectKey="operator_text"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>

                                    <BaseInput2
                                            label="Оператор(ы) (на английском)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="project.project_data.operator_text_english"
                                            v-if="isFieldVisible('operator_text_english')"
                                            objectKey="operator_text_english"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>

                                    <BaseInput2
                                            label="Композитор(ы)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="compositor_text"
                                            v-if="isFieldVisible('compositor_text')"
                                            objectKey="compositor_text"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>

                                    <BaseInput2
                                            label="Композитор(ы) (на английском)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="project.project_data.compositor_text_english"
                                            v-if="isFieldVisible('compositor_text_english')"
                                            objectKey="compositor_text_english"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>

                                    <BaseInput2
                                            label="Художник-постановщик(и)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="chudoznik_text"
                                            v-if="isFieldVisible('chudoznik_text')"
                                            objectKey="chudoznik_text"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>

                                    <BaseInput2
                                            label="Художник-постановщик(и) (на английском)"
                                            description="(перечислите через запятую, если больше одного)"
                                            v-model="project.project_data.chudoznik_text_english"
                                            v-if="isFieldVisible('chudoznik_text_english')"
                                            objectKey="chudoznik_text_english"
                                            :isDataUpdated="isDataUpdating"
                                            :isFormSubmitted="isSubmitted"
                                    ></BaseInput2>
                                </div>
                                <div class="column"></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="checkbox__wrapper">
                <input type="checkbox" @change="saveData" id="reglament_agreement" value="yes" v-model="project.project_data.reglament_agreement">
                <label class="req" for="reglament_agreement">Подтверждаю согласие с Регламентом Фестиваля</label>
            </div>

            <div class="checkbox__wrapper">
                <input type="checkbox" @change="saveData" id="policy_agreement" value="yes" v-model="project.project_data.policy_agreement">
                <label class="req" for="policy_agreement">Даю согласие на обработку персональных данных</label>
            </div>

            <div class="checkbox__wrapper">
                <input type="checkbox" @change="saveData" id="dostovernost_agreement" value="yes" v-model="project.project_data.dostovernost_agreement">
                <label class="req" for="dostovernost_agreement">Гарантирую достоверность заполненных данных</label>
            </div>

            <div class="checkbox__wrapper">
                <input type="checkbox" @change="saveData" id="pravoobladatel_agreement" value="yes" v-model="project.project_data.pravoobladatel_agreement">
                <label class="req" for="pravoobladatel_agreement">Гарантирую отправку анкеты для участия в Фестивале с согласия Правообладателя</label>
            </div>

            <div class="checkbox__wrapper">
                <input type="checkbox" @change="saveData" id="pravoobladatel_agreement2" value="yes" v-model="project.project_data.pravoobladatel_agreement2">
                <label class="req" for="pravoobladatel_agreement2">Гарантирую согласие Правообладателя при прохождении в конкурсную программу Фестиваля</label>
            </div>
        </form>
    </div>
    <div v-else style="text-align: center">
        <div class="lds-default">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
import BaseInput from "../Base/BaseInput.vue";
import BaseInput2 from "../Base/BaseInput2.vue";
import BaseInput3 from "../Base/BaseInput3.vue";
import TinymceEditor from "../Base/TinymceEditor.vue";
import BaseLocation from "../Base/BaseLocation.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';
library.add(faQuestion);
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from "axios";

export default {
  name: 'CompleteProjectForm106',
  props: {
    isDataUpdating: {},
    isSubmitted: {},
    selectedCompetition: {}
  },
  created() {
    this.isLoading = true;
    this.checkIsUserFillProfile().then(() => {
      //Если выбран активный конкурс, куда подается заявка.
      if (window.competitionId?.length > 0) {
        this.selectedCompetitionId = window.competitionId;
        //this.loadCompetition(this.selectedCompetitionId);
        this.$emit('loadCompetition', this.selectedCompetitionId)

        if (window.new.length > 0) {
          this.getData(false, false);
        } else {
          this.getData(true, true);
        }
      } else {
        //this.loadCompetitions(1);
        this.$emit('loadCompetitions', 1)

        //Если после добавления нового проекта.
        if (window.new.length > 0) {
          this.getData(false, false);
        } else {
          this.getData()
        }
      }
    });


    this.isLoading = false;
  },
  data() {
    return {
      imgSrc: '',
      project: null,
      isLoading: false,
      validationRules: [
        {
          "fieldName":"name_english",
					"fieldLabel":"Общая информация о проекте - Название фильма на английском языке",
					"errorText":"Поле \"Общая информация о проекте - Название фильма на английском языке\" обязательно для заполнения",
					"isRequired":true,
					"isNeeded":true,
					"parentEntity": "project_data"
        },
        {
          "fieldName":"annotation_english",
          "fieldLabel":"Общая информация о проекте - Краткая аннотация на английском языке",
          "errorText":"Поле \"Общая информация о проекте - Краткая аннотация на английском языке\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"scenarist_text_english",
          "fieldLabel":"Команда - Автор(ы) сценария (на английском)",
          "errorText":"Поле \"Команда - Автор(ы) сценария (на английском)",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_text_english",
          "fieldLabel":"Команда - Режиссер(ы) (на английском)",
          "errorText":"Поле \"Команды - Режиссер(ы) (на английском)\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_bio_english",
          "fieldLabel":"Команда - Краткая биография режиссера на английском языке",
          "errorText":"Поле \"Команда - Краткая биография режиссера на английском языке\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_filmografia",
          "fieldLabel":"Команда - Краткая фильмография режиссера на русском языке",
          "errorText":"Поле \"Команда - Краткая фильмография режиссера на русском языке\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_filmografia_english",
          "fieldLabel":"Команда - Краткая фильмография режиссера на английском языке",
          "errorText":"Поле \"Команда - Краткая фильмография режиссера на английском языке\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"producer_text_english",
          "fieldLabel":"Команда - Продюсер(ы) (на анлгийском)",
          "errorText":"Поле \"Команда - Продюсер(ы) (на анлгийском)\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"operator_text_english",
          "fieldLabel":"Команда - Оператор(ы) (на английском)",
          "errorText":"Поле \"Команда - Оператор(ы) (на английском)\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"compositor_text_english",
          "fieldLabel":"Команда - Композитор(ы) (на английском)",
          "errorText":"Поле \"Команда - Композитор(ы) (на английском)\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"chudoznik_text_english",
          "fieldLabel":"Команда - Художник-постановщик(и) (на английском)",
          "errorText":"Поле \"Команда - Художник-постановщик(и) (на английском)\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_photo",
          "fieldLabel":"Общая информация о проекте - Ссылка на фотографию режиссера",
          "errorText":"Поле \"Общая информация о проекте - Ссылка на фотографию режиссера\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_filmografia",
          "fieldLabel":"Команда - Краткая фильмография режиссера на русском языке",
          "errorText":"Поле \"Команда - Краткая фильмография режиссера на русском языке\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"regiser_filmografia_english",
          "fieldLabel":"Команда - Краткая фильмография режиссера на английском языке",
          "errorText":"Поле \"Команда - Краткая фильмография режиссера на английском языке\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"russian_subtitles",
          "fieldLabel":"Общая информация о проекте - Наличие русских субтитров - для фильмов на национальных и иностранных языках",
          "errorText":"Поле \"Общая информация о проекте - Наличие русских субтитров - для фильмов на национальных и иностранных языках\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        // {
        //   "fieldName":"russian_premiera",
        //   "fieldLabel":"Общая информация о проекте - российская премьера",
        //   "errorText":"Поле \"Общая информация о проекте - российская премьера\" обязательно для заполнения",
        //   "isRequired":true,
        //   "isNeeded":true,
        //   "parentEntity": "project_data"
        // },
        {
          "fieldName":"pravoobladatel",
          "fieldLabel":"Общая информация о проекте - Правообладатель",
          "errorText":"Поле \"Общая информация о проекте - Правообладатель\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"reglament_agreement",
          "fieldLabel":"Общая информация о проекте - Подтверждаю согласие с Регламентом Фестиваля",
          "errorText":"Поле \"Общая информация о проекте - Подтверждаю согласие с Регламентом Фестиваля\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"policy_agreement",
          "fieldLabel":"Общая информация о проекте - Даю согласие на обработку персональных данных",
          "errorText":"Поле \"Общая информация о проекте - Даю согласие на обработку персональных данных\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"reglament_agreement",
          "fieldLabel":"Общая информация о проекте - Подтверждаю согласие с Регламентом Фестиваля",
          "errorText":"Поле \"Общая информация о проекте - Подтверждаю согласие с Регламентом Фестиваля\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"dostovernost_agreement",
          "fieldLabel":"Общая информация о проекте - Гарантирую достоверность заполненных данных",
          "errorText":"Поле \"Общая информация о проекте - Гарантирую достоверность заполненных данных\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"pravoobladatel_agreement",
          "fieldLabel":"Общая информация о проекте - Гарантирую отправку анкеты для участия в Фестивале с согласия Правообладателя",
          "errorText":"Поле \"Общая информация о проекте - Гарантирую отправку анкеты для участия в Фестивале с согласия Правообладателя\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"pravoobladatel_agreement2",
          "fieldLabel":"Общая информация о проекте - Гарантирую согласие Правообладателя при прохождении в конкурсную программу Фестиваля",
          "errorText":"Поле \"Общая информация о проекте - Гарантирую согласие Правообладателя при прохождении в конкурсную программу Фестиваля\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true,
          "parentEntity": "project_data"
        },
        {
          "fieldName":"zhanr",
          "fieldLabel":"Общая информация о проекте - Вид фильма",
          "errorText":"Поле \"Общая информация о проекте - Вид фильма\" обязательно для заполнения",
          "isRequired":true,
          "isNeeded":true
        }
			],
      countriesinput: [],
      tabNum: 1,
      errors: [],
      commandphoto: '',
      inroles: '',
      scenarist_text: '',
      scenarist_phone: '',
      scenarist_email: '',
      scenarist_bio: '',
      regiser_text: '',
      regiser_phone: '',
      regiser_email: '',
      regiser_bio: '',
      producer_text: '',
      producer_phone: '',
      producer_email: '',
      producer_bio: '',
      operator_text: '',
      compositor_text: '',
      chudoznik_text: '',
      isUserFillProfile: false,
    }
  },
  components: {
    BaseInput,
    BaseInput2,
    BaseInput3,
    TinymceEditor,
    BaseLocation,
    VueCropper,
    FontAwesomeIcon
  },
  // computed: {},
  methods: {
    async getData(checkErrors = true, showModal = false) {
      const self = this;

      let project_data = {
        age_limit: '',
        treiler: '',
        premiera: ''
      };
      await axios.get('/api/projects/' + window.projectId, {
        headers: {
          'Accept': 'application/json',
        }
      })
        .then(response => {
          self.commandphoto = response.data?.project_command?.command_photo;
          self.inroles = response.data?.project_command?.inroles;
          self.scenarist_text = response.data?.project_command?.scenarist_text;
          self.scenarist_phone = response.data?.project_command?.scenarist_phone;
          self.scenarist_email = response.data?.project_command?.scenarist_email;
          self.scenarist_bio = response.data?.project_command?.scenarist_bio;
          self.regiser_text = response.data?.project_command?.regiser_text;
          self.regiser_phone = response.data?.project_command?.regiser_phone;
          self.regiser_email = response.data?.project_command?.regiser_email;
          self.regiser_bio = response.data?.project_command?.regiser_bio;
          self.producer_text = response.data?.project_command?.producer_text;
          self.producer_phone = response.data?.project_command?.producer_phone;
          self.producer_bio = response.data?.project_command?.producer_bio;
          self.producer_email = response.data?.project_command?.producer_email;
          self.operator_text = response.data?.project_command?.operator_text;
          self.compositor_text = response.data?.project_command?.compositor_text;
          self.chudoznik_text = response.data?.project_command?.chudoznik_text;

          self.project = response.data;

          if (self.project.project_data === null || Array.isArray(self.project.project_data)) {
            self.project.project_data = {};
          }

          for (var key in project_data) {
            if (key === 'needed_resourses') {
              //self.project.project_data[key] = response.data.project_data[key] ?? [];
            } else {
              self.project.project_data[key] = response.data.project_data[key] ?? '';
            }
          }

          if (checkErrors) {
            if (showModal) {
              self.checkErrors(false, true);
            } else {
              self.checkErrors(false);
            }
          }

          self.$parent.isLoading = false;
          self.$parent.isDataUpdating = false;
        })
        .catch(error => {
          console.log(error);
        });

      if (self.countriesinput.length === 0) {
        await this.loadCountries();
      }
    },
    saveData: function () {
      let self = this;
      if (!this.isDataUpdating) {
        this.$parent.isDataUpdating = true;

        axios.patch('/api/projects/' + window.projectId,
          {
            'name': this.project.name,
            'publishYear': parseInt(this.project.publish_year),
            'chronometr': this.project.chronometr,
            'zhanr': this.project.zhanr,
            'production': this.project.production,
            'annotation': this.project.annotation,
            'filmRights': this.project.film_rights,
            'filmRightsPhone': this.project.film_rights_phone,
            'filmRightsEmail': this.project.film_rights_email,
            'videoLink': this.project.video_link,
            'tagline': this.project.tagline,
            'socialVideolink': this.project.social_videolink,
            'videoSource': this.project.video_source,
            'prioritySocial': this.project.priority_social,
            'musicRights': this.project.music_rights,
            'filmLanguage': this.project.film_language,
            'motivation': this.project.motivation,
            'country': this.project.country,
            'city': this.project.city,
            'region': this.project.region,
            'projectCommand': {
              'commandPhoto': this.commandphoto,
              'inroles': this.inroles,
              'scenaristText': this.scenarist_text,
              'scenaristPhone': this.scenarist_phone,
              'scenaristEmail': this.scenarist_email,
              'scenaristBio': this.scenarist_bio,
              'regiserText': this.regiser_text,
              'regiserPhone': this.regiser_phone,
              'regiserEmail': this.regiser_email,
              'regiserBio': this.regiser_bio,
              'producerText': this.producer_text,
              'producerPhone': this.producer_phone,
              'producerEmail': this.producer_email,
              'producerBio': this.producer_bio,
              'operatorText': this.operator_text,
              'compositorText': this.compositor_text,
              'chudoznikText': this.chudoznik_text
            },
            'projectData': this.project.project_data
          },
          {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/merge-patch+json',
            }
          }
        ).then((response) => {
          if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
            alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
            window.location.reload();
          }

          self.getData()
        }).catch(error => {
          console.log(error);
          alert('Ошибка получения данных')
        });
      }
    },
    changeCurrentTab(num) {
      this.tabNum = num;
      document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
    },
    isRequired(value) {
      return !(value && value.trim());
    },
    validateField(field) {
      const self = this;
      if (field.parentEntity !== undefined) {
        if (self.project) {
          if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0 || self.project[field.parentEntity][field.fieldName] === false))) {
            if (!self.errors.find(x => x.text === field.errorText)) {
              self.errors.push({
                text: field.errorText,
                order: field.order ? field.order : '1'
              });
            }
          }
        }
      } else {

        if (self.project) {
          if (field.isRequired && (self.project[field.fieldName] === null || self.project[field.fieldName]?.length === 0 || self.project[field.fieldName] === 0)) {
            if (!self.errors.find(x => x.text === field.errorText)) {
              self.errors.push({
                text: field.errorText,
                order: field.order ? field.order : '1'
              });
            }
          }
        }
      }
    },
    isFieldVisible(fieldName) {
      let res = true;
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if ((field.fieldName === fieldName || field?.altFieldName === fieldName) && !field.isRequired && !field.isNeeded) {
            res = false;
          }
        });
      }
      return res;
    },
    isFieldRequired(fieldName) {
      let res = false;
      this.validationRules.forEach(function (field) {
        if (
          (field.fieldName === fieldName || field?.altFieldName === fieldName)
          && field.isRequired) {
          res = true;
        }
      });
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if (
            (field.fieldName === fieldName || field?.altFieldName === fieldName)
            && field.isRequired) {
            res = true;
          }
        });
      }
      return res;
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Загрузить можно только изображение");
        return;
      }
      if (file.size > 1572864) {
        alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
        return;
      }
      this.origfilename = file.name;
      const self = this;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          self.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          if (self.$refs.cropper) {
            self.$refs.cropper.replace(event.target.result);
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      const self = this;
      this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
        let formData = new FormData();
        formData.append('file', blob);
        formData.append('original-name', self.origfilename);
        formData.append('current-name', self.project.afisha);
        formData.append('entity-id', self.project.id);

        axios(
          {
            method: 'post',
            url: '/project/getProjectAvatar',
            data: formData
          }
        )
          .then(() => {
            self.imgSrc = '';
            self.getData();

          });
      })
    },
    checkErrors(withScroll = true, showModal = false) {
      const self = this;
      this.isLoading = true;

      self.errors = [];

      this.validationRules.forEach(function (field) {
        self.validateField(field)
      });
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          self.validateField(field)
        });
        this.errors.sort((a, b) => a.order > b.order ? 1 : -1);
      }

      if (!self.isUserFillProfile) {
        self.errors.push({
          text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/myprofile?check=true">https://script.moviestart.ru/myprofile</a>',
          order: '1'
        });
      }
      if (showModal) {
        self.$parent.showModal();
      }
      self.isLoading = false;
      self.$parent.isLoading = false;
      if (withScroll && self.errors.length > 0) {
        if (document.getElementById("project_form")) {
          document.getElementById("project_form").scrollIntoView();
        }
      }
    },
    checkIsUserFillProfile() {
      return new Promise((resolve, reject) => {
        const self = this;
        axios.get('/isUserFillProfile', {
          headers: {
            'Accept': 'application/json',
          }
        })
          .then(response => {
            self.isUserFillProfile = response.data;
            resolve(response.data)
          })
          .catch(error => {
            console.log(error);
            reject(error)
          });
      });
    },
    async loadCountries() {
      const response = await axios.get('/get_all_countries', {
        headers: {
          'Accept': 'application/json',
        }
      })
      this.countriesinput = response.data;
    },
    loadCities() {
      const self = this;
      const current_country = self.countriesinput.filter(function (el) {
        return el["ru_name"] === self.project.country;
      })
      if (current_country[0] && current_country[0].number) {
        axios.get('/get_world_cities/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {
          self.citiestoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
  },
  watch: {
    selectedCompetition(val) {
      this.checkErrors();
    },
    errors(val) {
      this.$emit('onErrorsChange', this.errors)
    }
  }
}
</script>

<style scoped>
.field_description {
    font-size: 13px;
}

.modal {
    display: block;
    width: 80%;
    max-width: 950px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 20px;
    text-align: center;
    margin: 30px auto 30px;
    position: relative;
}

.category_select_active {
    font-weight: bold;
}

.close_button {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
}

.vue-universal-modal {
    z-index: 111;
}

.errors-block {
    color: red;
    border: 1px solid #999;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
}

.lds-default {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transform: scale(0.5);
    text-align: center;
}

.lds-default div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #000;
    border-radius: 50%;
    animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
    animation-delay: 0s;
    top: 37px;
    left: 66px;
}

.lds-default div:nth-child(2) {
    animation-delay: -0.1s;
    top: 22px;
    left: 62px;
}

.lds-default div:nth-child(3) {
    animation-delay: -0.2s;
    top: 11px;
    left: 52px;
}

.lds-default div:nth-child(4) {
    animation-delay: -0.3s;
    top: 7px;
    left: 37px;
}

.lds-default div:nth-child(5) {
    animation-delay: -0.4s;
    top: 11px;
    left: 22px;
}

.lds-default div:nth-child(6) {
    animation-delay: -0.5s;
    top: 22px;
    left: 11px;
}

.lds-default div:nth-child(7) {
    animation-delay: -0.6s;
    top: 37px;
    left: 7px;
}

.lds-default div:nth-child(8) {
    animation-delay: -0.7s;
    top: 52px;
    left: 11px;
}

.lds-default div:nth-child(9) {
    animation-delay: -0.8s;
    top: 62px;
    left: 22px;
}

.lds-default div:nth-child(10) {
    animation-delay: -0.9s;
    top: 66px;
    left: 37px;
}

.lds-default div:nth-child(11) {
    animation-delay: -1s;
    top: 62px;
    left: 52px;
}

.lds-default div:nth-child(12) {
    animation-delay: -1.1s;
    top: 52px;
    left: 62px;
}

.competition_wrapper {
    position: relative;
    max-width: 355px;
}

.modal .columns.is-multiline {
    justify-content: center;
}

.modal .columns.is-multiline .col1 {
    margin-right: 50px;
    margin-bottom: 70px;
}

.competiton_order_button_div {
    display: none;
}

.competition-info {
    background: #FEF4E5;
    padding: 20px;
}

.competition-image-wrapper {
    position: relative;
    display: flex;
    border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
    font-size: 21px;
}

.vue-universal-modal {
    z-index: 111;
}

.competition-title__wrapper {
    line-height: 1;
}

.competition-title {
    font-size: 16px;
}

.category_select {
    font-size: 18px;
}

.content_block .tabs ul {
    align-items: inherit;
}

.content_block .tabs ul li {
    display: flex;
}

.category_select:hover {
    color: #F69F22;
    cursor: pointer;
}

.competition_wrapper_inner:hover .competiton_order_button_div {
    display: block;
}
.help_text {
    margin-bottom: 30px;
    margin-top: 30px;
    font-style: italic;
    color: #8F9194;
    cursor: pointer;
}

.help_text svg {
    margin-right: 10px;
}
.modal_question {
    text-align: left;
    font-size: 16px;
}
input[type=radio] {
		display: none;
}
@keyframes lds-default {
    0%, 20%, 80%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
}
</style>
